export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '7e257289-7122-4585-ae75-a7d47642b3c4';
export const MODAL_CLOSE_SEC = 2.5;
